import { useState } from "react";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

function AddCompanyModal({ onClose, onAddCompany }) {
  const [formData, setFormData] = useState({
    name: "",
    desc: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const accessToken = localStorage.getItem("access_token");

    fetch(getApiUrl("/PartnerFiles/companies/"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add company");
        }
        return response.json();
      })
      .then((data) => {
        alert("Company added successfully!");
        onAddCompany(data);
        onClose();
      })
      .catch((error) => console.error("Error adding company:", error));
  };

  return (
    <div
      className="fixed inset-0 flex justify-center items-center z-50"
      id="marketingmodalopen"
      style={{ width: "100vw", height: "100vh" }}
    >
      {/* <div className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"></div> */}
      <div
        className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
        style={{
          width: "100vw",
          height: "150%",
          background: "black",
          backgroundSize: "200% 200vh",
          overflowY: "hidden",
          paddingBottom: "150px",
        }}
      ></div>
      {/* <div className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg" style={{ marginTop: "100px" }}> */}
      <div
        className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg"
        style={{
          // marginTop: "50px",
          height: "95vh", // Set height to allow scrolling
          overflowY: "auto", // Enable scrolling inside modal
        }}
      >
        <div
          className="overflow-auto max-h-[80vh]"
          style={{ padding: "100px", paddingTop: "20px" }}
        >
          <h2 className="text-center text-blue-700 mb-5">Add Company</h2>
          <button
            type="button"
            onClick={onClose}
            className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-red-700 transition-colors"
            style={{ position: "absolute", top: "20px", right: "20px" }}
          >
            X
          </button>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1">
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700"
              >
                Company Name
              </label>
              <input
                id="name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter company name"
              />
            </div>

            <div className="space-y-1">
              <label
                htmlFor="desc"
                className="block text-sm font-medium text-gray-700"
              >
                Description
              </label>
              <textarea
                id="desc"
                name="desc"
                value={formData.desc}
                onChange={handleChange}
                required
                rows="3"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter company description"
              />
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Save Company
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddCompanyModal;
